// Marquee title effect
function marqueeTitle() {
    const originalTitle = "RH";
    const titles = [
        "RH ☻",
        "RH ☻☻",
        "RH ☻☻☻",
        "RH ☻☻☻☻",
        "RH ☻☻☻",
        "RH ☻☻",
    ];
    
    let currentIndex = 0;
    
    setInterval(() => {
        document.title = titles[currentIndex];
        currentIndex = (currentIndex + 1) % titles.length;
    }, 1000);
}

document.addEventListener('DOMContentLoaded', marqueeTitle);